import { render, staticRenderFns } from "./ServiceTable.vue?vue&type=template&id=df943ae2&scoped=true"
import script from "./ServiceTable.vue?vue&type=script&lang=js"
export * from "./ServiceTable.vue?vue&type=script&lang=js"
import style0 from "./ServiceTable.vue?vue&type=style&index=0&id=df943ae2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df943ae2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VDivider,VRow})
